<template>
    <div :ref="id" :style="{width:width,height:height}"></div>
</template>

<script>
import echarts from "echarts";

export default {
  props: {
    width: { type: String, default: "100%" },
    height: { type: String, default: "300px" },
    xData: { type: Array, required: false },
    yData: { type: Array, required: false },
    title: { type: String, required: false },
    tooltipName: { type: String, default: "模拟数据" },
    tooltipColor: { type: String, default: "rgb(255, 70, 131)" },
    areaColor: { type: Array, required: false }
  },
  data() {
    return {
      id: null,
      option: {
        tooltip: {
          trigger: "axis",
          position: function(pt) {
            return [pt[0], "10%"];
          }
        },
        title: {}, // 头部标题  例：  {left:'center',text:'大数据量面积图'}
        xAxis: {}, // X轴      例：  {type: "category", boundaryGap: false,data: date}
        yAxis: {}, // Y轴      例：  { type: "value",boundaryGap: [0, "100%"]}
        series: [], // 图标配置
        toolbox: {}, // 工具栏
        dataZoom: [] // 缩放组件
      }
    };
  },
  created() {
    this.id = Math.random();
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.option.title = {
        left: "center",
        subtext: null,
        text: this.title
      };
      this.option.xAxis = {
        type: "category",
        boundaryGap: ["5%", "20%"],
        data: this.xData
      };
      this.option.yAxis = {
        type: "value",
        boundaryGap: ["5%", "5%"]
      };

      const serie = {
        name: this.tooltipName,
        type: "line",
        smooth: true, // 设置光滑
        symbol: "none",
        sampling: "average", // 取样 ：平均值
        itemStyle: {
          // 光标显示样式
          color: this.tooltipColor
        },
        // 设置颜色  offset：0~1
        areaStyle: {
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            this.areaColor
              ? this.areaColor
              : [
                  {
                    offset: 0,
                    color: "rgb(255,158,68)"
                  },
                  {
                    offset: 1,
                    color: "rgb(255,70,131)"
                  }
                ]
          )
        },
        data: this.yData
      };
      this.option.series = [serie];
      let myChart = echarts.init(this.$refs[this.id]);
      myChart.setOption(this.option);
    }
  },
  watch: {
    yData() {
      this.init();
    },
    xData() {
      this.init();
    }
  }
};
</script>
